const onDownload = (base64, name) => {
  if (base64) {
    const a = document.createElement("a")
    a.style = "display: none"

    a.href = base64
    a.download = `personalized-${name}`
    document.body.appendChild(a)
    a.click()
  }
}

export default onDownload
